// 定义状态常量
export const types = {
    INIT: '/user/page/expertedit/init',
    INPUT: '/user/page/expertedit/input',
    CLEAR: '/user/page/expertedit/clear'
};

const initState:IExpertEditStoreState = {
    name: '', 
    post: '',
    email: '',
    tel: '',
    companyName: '',
    industry: [],
    otherIndustry: '',
    field: [],
    logo: '',
    introduction: '',
    agreement: false
}

// 定义状态state接口
export interface IExpertEditStoreState { 
    name: string; // 姓名
    post: string; // 职位
    email: string; // email
    tel: string; // 手机号码
    companyName: string; // 公司名称
    industry: string[]; // 行业
    otherIndustry: string; // 其他行业
    field: string[]; // 领域
    logo: any; // logo
    introduction: string; // 自我介绍
    agreement: boolean; // 协议
}

// 定义行为action接口

export interface IExpertEditAction { 
    type: string;
    data?: {
        key: string;
        value: any;
    };
    initData?: any;
}

// 导出默认处理方法
export default (state: IExpertEditStoreState = initState, action: IExpertEditAction):IExpertEditStoreState => { 
    switch (action.type) { 
        case types.INPUT:
            return {
                ...state,
                [action.data!.key]: action.data!.value
            }
        case types.INIT:
            if (action.initData) {
                const expert = action.initData;
                const field = [];
                if (expert.field1) { 
                    field.push(expert.field1);
                }
                if (expert.field2) { 
                    field.push(expert.field2);
                }
                if (expert.field3) { 
                    field.push(expert.field3);
                }
                return {
                    name: expert.fullname || '', 
                    post: expert.job || '',
                    email: expert.email || '',
                    tel: expert.mobile || '',
                    companyName: expert.expertCompany || '',
                    industry: expert.industry ? expert.industry.split(',') : [],
                    otherIndustry: expert.industryOther || '',
                    field,
                    logo: expert.logo || '',
                    introduction: expert.description || '',
                    agreement: true  
                }
            } else { 
                return state;
            }
        case types.CLEAR:
            return initState;
        default:
            return state;
    }
}